var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#7986CB",
    cx: 14,
    cy: 14,
    r: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.689,
    d: "m8.201 13.86 5.775 3.412V4.278z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.686,
    d: "M13.976 4.278v12.994l5.774-3.412z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m8.201 14.954 5.775 8.137v-4.724z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M13.976 18.367v4.724l5.778-8.137z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.698,
    d: "M13.976 11.234 8.201 13.86l5.775 3.412 5.774-3.412z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.4012e4e1d32948eaabe2990142de185a.svg";
export { ForwardRef as ReactComponent };